
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz'
import Descriptor from '@/components/Descriptor'
import DescriptorModel from '@/models/Descriptor'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h2" components={components} props={{"id":"descriptor"}}>{`Descriptor`}</MDXTag>
<Playground __position={0} __code={'<Descriptor\n  model={DescriptorModel.create({\n    name: \'Hair Color\',\n    value: \'Brown\',\n  })}\n/>'} __scope={{props: this ? this.props : props,Descriptor,DescriptorModel}}>
  <Descriptor model={DescriptorModel.create({
    name: 'Hair Color',
    value: 'Brown',
  })} />
</Playground>
           </MDXTag>
  }
}
  